var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-articles",style:(_vm.changeBackground(_vm.topData.srcImg))},[(_vm.topData.visibility)?_c('div',{staticClass:"top-articles__text"},[_c('div',[_vm._v(_vm._s(_vm.topData.heading))]),_c('nav',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")]),_vm._v(" / "),_c('a',[_vm._v(_vm._s(_vm.topData.link))])],1)]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }